import MayoClinic from '@public/leading-experts/mayo-clinic.svg?component';
import NBA from '@public/leading-experts/nba.svg?component';
import OlympicCommittee from '@public/leading-experts/olympic-committee.svg?component';
import UCSFHealth from '@public/leading-experts/ucsf-health.svg?component';
import clsx from 'clsx';
import Image from 'next/image';

import { Alter25Button } from '@/components/alter25/Alter25Button';

export const ShopSwabKitLeadingExperts: React.FC = () => {
  return (
    <div className="container">
      <div className="flex justify-center items-center flex-col">
        <h3
          className={clsx(
            'font-light text-center mb-4',
            'mt-4 text-[24px] leading-[28.8px] tracking-[-0.72px]',
            'md:mt-6 md:text-[40px] md:leading-[48px] md:tracking-[-1.2px]',
            'max-w-[440px]',
            'md:max-w-[740px]'
          )}
        >
          Developed by top experts in health, nutrition, and weight loss.
        </h3>
        <h3
          className={clsx(
            'font-light text-center',
            'text-base leading-[22.4px] tracking-[-0.48px]',
            'md:text-[18px] md:leading-[25.2px] md:tracking-[-0.54px]',
            'md:max-w-[768px]'
          )}
        >
          We’ve brought together the brightest minds in health and fitness to deliver cutting-edge
          science, expert guidance, and proven strategies for lasting results.
        </h3>

        <div
          className={clsx(
            'my-10 md:my-16',
            'flex flex-wrap justify-around items-center',
            'gap-x-[12px] gap-y-[24px]',
            'sm:gap-x-[72px] md:gap-y-[36px]',
            'lg:gap-x-[36px] lg:gap-y-[36px]',
            'md:max-w-[1000px]',
            'lg:w-full'
          )}
        >
          <NBA className="w-[49px] h-[28px] md:w-[69px] md:h-[39px]" />
          <Image
            src="/leading-experts/stanford.webp"
            width={388}
            height={88}
            alt="Stanford Sleep Medicine"
            className="w-[123.5px] h-[28px] md:w-[172px] md:h-[39px]"
          ></Image>
          <Image
            src="/leading-experts/notre-dame.webp"
            width={122}
            height={111}
            alt="Notre Dame"
            className="w-[30.8px] h-[28px] md:w-[42.8px] md:h-[39px]"
          ></Image>
          <MayoClinic className="w-[34px] h-[28px] md:w-[47.8px] md:h-[39px]" />
          <UCSFHealth className="h-[28px] md:h-[39px]" />
          <OlympicCommittee className="w-[118.8px] h-[28px] md:w-[165.5px] md:h-[39px]" />
        </div>

        <Alter25Button text="About us" href="/who-we-are" size="lg" style="white" arrow />
      </div>
    </div>
  );
};
